import React, { Component } from 'react';
import { Route }            from 'react-router-dom';
import 'video-react/dist/video-react.css';
import './App.css';

import Drawer     from './components/Navigation/Drawer/Drawer';
import MenuToggle from './components/Navigation/MenuToggle/MenuToggle';

import MkCases2021 from "./pages/MkCases2021";
import STA from './pages/STA';
import ExampleDay1 from './pages/ExampleDay1';
import ExampleDay2 from './pages/ExampleDay2';

class App extends Component {

    state = {
        menu: false,
        isVisible: true,
        links: [
            //MkCases2021
            { to: '/mkcases2021', label: 'МК Кейсы 2021', exact: false },
            { to: '/sta', label: 'Summer Tagline Awards', exact: false },
            { to: '/example/day1', label: 'Тестовое событие', exact: false },
            { to: '/example/day2', label: 'Тестовое событие 2', exact: false }
        ]
    };

    toggleMenuHandler = () => {
        this.setState((prevState) => ({
            menu: !prevState.menu
        }));
    };

    menuCloseHandler = () => {
        this.setState({
            menu: false
        });
    };

    render() {
        return (
            <div className="b-app">
                <Drawer
                    links={ this.state.links }
                    isOpen={ this.state.menu }
                    onClose={ this.menuCloseHandler }
                />

                <MenuToggle
                    onToggle={ this.toggleMenuHandler }
                    isOpen={ this.state.menu }
                />

                <Route path={ this.state.links[0].to } exact component={ MkCases2021 }/>
                {/*<Route path={ this.state.links[1].to } exact component={ STA }/>*/}
                {/*<Route path={ this.state.links[2].to } exact component={ ExampleDay1 }/>*/}
                {/*<Route path={ this.state.links[3].to } exact component={ ExampleDay2 }/>*/}
            </div>
        );
    }
}

export default App;
